import { DESK_COMMUNICATION_EVENTS, DESK_COMMUNICATION_STATUSES } from "../../../../util/communication_statuses";

export const getEventName = (event, comm, t) => {
  switch (event.type) {
    case DESK_COMMUNICATION_EVENTS.CHECKIN_SENT:
      return t("cc_sent").message || "Sent";
    case DESK_COMMUNICATION_EVENTS.CHECKIN_RECEIVED:
      return t("cc_received").message || "Received";
    case DESK_COMMUNICATION_EVENTS.CHECKIN_FAILED_TO_OPEN:
      return t("cc_failed_to_open").message || "Failed to open";
    case DESK_COMMUNICATION_EVENTS.CHECKIN_OPENED:
      return t("cc_opened").message || "Opened";
    case DESK_COMMUNICATION_EVENTS.CHECKIN_CANCELED:
      return t("cc_canceled").message || "Canceled";
    case DESK_COMMUNICATION_EVENTS.CHECKIN_ANSWERED:
      return t("cc_answered").message || "Answered";
    default:
      if (comm.status === DESK_COMMUNICATION_STATUSES.CHECKIN_CLOSED) return t("cc_closed").message || "Closed";
      return "";
  }
};
